export class ApiProgressEvent {
    progressPercent;
    constructor(progressEvent) {
        const progress = progressEvent.progress ?? 0;
        this.progressPercent = Math.floor(progress * 100);
    }
}
